document.querySelectorAll('.calendar__carousel').forEach((carousel) => {
    const swiperEl = carousel.querySelector('.calendar__swiper');
    if (!swiperEl) return;

    const initialSlide = parseInt(swiperEl.dataset.initialSlide, 10) || 0;

    new Swiper(swiperEl, {
        initialSlide,
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: 2.2,
                centeredSlides: true,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 24,
            },
            1200: {
                slidesPerView: 4,
                centeredSlides: false,
                spaceBetween: 24,
            },
        },
    });
});
